import { Component, Input, OnInit } from '@angular/core';
import { provideTranslocoScope, TranslocoService } from '@ngneat/transloco';
import { map, Observable } from 'rxjs';
import { PLATFORM_MATOMO_EVENT_CATEGORY_LEGAL, PLATFORM_MATOMO_EVENT_CATEGORY_LINKS } from '../../platform-matomo-events';
import { PLATFORM_TRANSLOCO_SCOPE } from '../../platform-transloco-scope';
import { YATTA_IMPRINT_URL, YATTA_PRIVACY_POLICY_URL, YATTA_TERMS_OF_SERVICE_URL } from '../legal-links';
import { LegalWording } from '../legal-wording';

/**
 * Styled with:
 * - --footer-width: width of the footer
 * - --footer-min-width: min width of the footer
 * - --footer-border-radius: radius border of the footer
 * - --footer-container-width: width of the footer container
 * - --footer-container-min-width: minimum width of the footer container
 * - --footer-padding: padding of the footer
 * - --footer-background-color: background color of the footer
 * - --footer-border-color: color of the upper border of the footer
 * - --footer-container-height: height of the inner container
 * - --footer-mobile-container-height: height of the inner container for mobile devices
 * - --footer-container-line-height: line height of the inner container
 * - --footer-container-padding: padding of the inner container
 * - --footer-font-size: font-size of links and text
 * - --footer-logo-font-color: color of the font of the logo
 * - --footer-logo-font-color-hover: color of the font of the logo on hover
 * - --footer-logo-padding: padding of the logo
 * - --footer-logo-width: width of the logo
 * - --footer-logo-height: height of the logo
 * - --footer-link-color: color of links
 * - --footer-link-color-hover: color of links on hover
 * - --footer-text-color: color of text
 * - --footer-margin-text-to-logo: margin between text and logo
 * - --footer-legal-links-margin-bottom: maring below legal links
 */
@Component({
  selector: 'yat-powered-by-footer',
  templateUrl: './powered-by-footer.component.html',
  styleUrls: ['./powered-by-footer.component.scss'],
  providers: [provideTranslocoScope(PLATFORM_TRANSLOCO_SCOPE)]
})
export class PoweredByFooterComponent implements OnInit {
  constructor(private translocoService: TranslocoService) {}

  @Input()
  staticKeys?: Record<LegalWording, string>;

  readonly MATOMO_EVENT_CATEGORY_FOOTER = PLATFORM_MATOMO_EVENT_CATEGORY_LEGAL;
  readonly MATOMO_EVENT_CATEGORY_LINKS = PLATFORM_MATOMO_EVENT_CATEGORY_LINKS;

  readonly IMPRINT_URL = YATTA_IMPRINT_URL;
  TERMS_OF_SERVICE_URL$: Observable<string>;
  PRIVACY_POLICY_URL$: Observable<string>;

  ngOnInit(): void {
    this.TERMS_OF_SERVICE_URL$ = this.translocoService.langChanges$.pipe(map(lang => YATTA_TERMS_OF_SERVICE_URL(lang)));
    this.PRIVACY_POLICY_URL$ = this.translocoService.langChanges$.pipe(map(lang => YATTA_PRIVACY_POLICY_URL(lang)));
  }
}
